import { NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';
import { TabsPage } from './pages/tabs/tabs.page';

const routes: Routes = [
  {
    path: 'tabs', component: TabsPage,
    children:[
      {
        path: '',
        pathMatch: 'full',
        redirectTo: 'home',
      },
      {
        path: 'home',
        loadChildren: () => import('./pages/home/home.module').then( m => m.HomePageModule),
      },
      {
        path: 'settings',
        loadChildren: () => import('./pages/settings/settings.module').then( m => m.SettingsPageModule)
      },
      {
        path: 'my-profile-display',
        loadChildren: () => import('./pages/my-profile-display/my-profile-display.module').then( m => m.MyProfileDisplayPageModule)
      },
      {
        path: 'chat-list',
        loadChildren: () => import('./pages/chat-list/chat-list.module').then( m => m.ChatListPageModule)
      },
      {
        path: 'super-like',
        loadChildren: () => import('./pages/super-like/super-like.module').then( m => m.SuperLikePageModule)
      }],
  },
  {
    path: '',
    loadChildren: () => import('./pages/login/login.module').then( m => m.LoginPageModule)
  },
  {
    path: 'tabs',
    loadChildren: () => import('./pages/tabs/tabs.module').then(m => m.TabsPageModule)
  },
  {
    path: 'login',
    loadChildren: () => import('./pages/login/login.module').then( m => m.LoginPageModule)
  },
  {
    path: 'default-login',
    loadChildren: () => import('./pages/default-login/default-login.module').then( m => m.DefaultLoginPageModule)
  },
  {
    path: 'onboarding-flow',
    loadChildren: () => import('./pages/onboarding-flow/onboarding-flow.module').then( m => m.OnboardingFlowPageModule)
  },
  {
    path: 'signup-with-email',
    loadChildren: () => import('./pages/signup-with-email/signup-with-email.module').then( m => m.SignupWithEmailPageModule)
  },
  {
    path: 'forgot-password',
    loadChildren: () => import('./pages/forgot-password/forgot-password.module').then( m => m.ForgotPasswordPageModule)
  },
  {
    path: 'reset-password',
    loadChildren: () => import('./pages/reset-password/reset-password.module').then( m => m.ResetPasswordPageModule)
  },
  {
    path: 'email-validation',
    loadChildren: () => import('./pages/email-validation/email-validation.module').then( m => m.EmailValidationPageModule)
  },
  {
    path: 'profile',
    loadChildren: () => import('./pages/profile/profile.module').then( m => m.ProfilePageModule)
  },
  {
    path: 'pictures',
    loadChildren: () => import('./pages/pictures/pictures.module').then( m => m.PicturesPageModule)
  },
  {
    path: 'generic-choice',
    loadChildren: () => import('./pages/generic-choice/generic-choice.module').then( m => m.GenericChoicePageModule)
  },
  {
    path: 'generic-input',
    loadChildren: () => import('./pages/generic-input/generic-input.module').then( m => m.GenericInputPageModule)
  },
  {
    path: 'interest',
    loadChildren: () => import('./pages/interest/interest.module').then( m => m.InterestPageModule)
  },
  {
    path: 'height',
    loadChildren: () => import('./pages/height/height.module').then( m => m.HeightPageModule),
    
  },
  {
    path: 'looking-for',
    loadChildren: () => import('./pages/looking-for/looking-for.module').then( m => m.LookingForPageModule),
    
  },
  {
    path: 'my-profile-display',
    loadChildren: () => import('./pages/my-profile-display/my-profile-display.module').then( m => m.MyProfileDisplayPageModule),
    
  },
  {
    path: 'settings',
    loadChildren: () => import('./pages/settings/settings.module').then( m => m.SettingsPageModule)
  },
  {
    path: 'store-home',
    loadChildren: () => import('./pages/store-home/store-home.module').then( m => m.StoreHomePageModule),
    
  },
  {
    path: 'preferences',
    loadChildren: () => import('./pages/preferences/preferences.module').then( m => m.PreferencesPageModule)
  },
  {
    path: 'privacy',
    loadChildren: () => import('./pages/privacy/privacy.module').then( m => m.PrivacyPageModule)
  },
  {
    path: 'help-page',
    loadChildren: () => import('./pages/help-page/help.module').then( m => m.HelpPageModule)
  },
  {
    path: 'hidden-profiles',
    loadChildren: () => import('./pages/hidden-profiles/hidden-profiles.module').then( m => m.HiddenProfilesPageModule)
  },
  {
    path: 'survey',
    loadChildren: () => import('./pages/survey/survey.module').then( m => m.SurveyPageModule)
  },
  {
    path: 'super-like',
    loadChildren: () => import('./pages/super-like/super-like.module').then( m => m.SuperLikePageModule)
  },
  {
    path: 'manage-account',
    loadChildren: () => import('./pages/manage-account/manage-account.module').then( m => m.ManageAccountPageModule)
  },
  {
    path: 'hibernate',
    loadChildren: () => import('./pages/hibernate/hibernate.module').then( m => m.HibernatePageModule)
  },
  {
    path: 'store',
    loadChildren: () => import('./pages/store/store.module').then( m => m.StorePageModule)
  },
  {
    path: 'email-preferences',
    loadChildren: () => import('./pages/email-preferences/email-preferences.module').then( m => m.EmailPreferencesPageModule)
  },
  {
    path: 'unsubscribe',
    loadChildren: () => import('./pages/email-preferences/email-preferences.module').then( m => m.EmailPreferencesPageModule)
  },
  {
    path: 'home',
    loadChildren: () => import('./pages/home/home.module').then( m => m.HomePageModule),
    
  },
  {
    path: 'store-v2',
    loadChildren: () => import('./pages/store-v2/store-v2.module').then( m => m.StoreV2PageModule)
  },
  {
    path: 'teleportation',
    loadChildren: () => import('./pages/teleportation/teleportation.module').then( m => m.TeleportationPageModule)
  },
  {
    path: 'profile-display',
    loadChildren: () => import('./pages/profile-display/profile-display.module').then( m => m.ProfileDisplayPageModule)
  },
  {
    path: 'veg-match',
    loadChildren: () => import('./pages/veg-match/veg-match.module').then( m => m.VegMatchPageModule)
  },
  {
    path: 'super-like-txt-entry',
    loadChildren: () => import('./pages/super-like-txt-entry/super-like-txt-entry.module').then( m => m.SuperLikeTxtEntryPageModule)
  },
  {
    path: 'recadinho',
    loadChildren: () => import('./pages/recadinho/recadinho.module').then( m => m.RecadinhoPageModule)
  },
  {
    path: 'referral-confirmation',
    loadChildren: () => import('./pages/referral-confirmation/referral-confirmation.module').then( m => m.ReferralConfirmationPageModule)
  },
  {
    path: 'tutorial',
    loadChildren: () => import('./pages/tutorial/tutorial.module').then( m => m.TutorialPageModule)
  },
  {
    path: 'avocado-promotion',
    loadChildren: () => import('./pages/avocado-promotion/avocado-promotion.module').then( m => m.AvocadoPromotionPageModule)
  },
  {
    path: 'login-shared',
    loadChildren: () => import('./pages/login-shared/login-shared.module').then( m => m.LoginSharedPageModule)
  },
  {
    path: 'promotions/:type',
    loadChildren: () => import('./pages/store-v2/store-v2.module').then( m => m.StoreV2PageModule)
  },
  {
    path: 'chat/:userId',
    loadChildren: () => import('./pages/chat/chat.module').then( m => m.ChatPageModule)
  },
  {
    path: 'instructions-check-profile',
    loadChildren: () => import('./pages/instructions-check-profile/instructions-check-profile.module').then( m => m.InstructionsCheckProfilePageModule)
  },
  {
    path: 'take-phone-one',
    loadChildren: () => import('./pages/take-phone-one/take-phone-one.module').then( m => m.TakePhoneOnePageModule)
  },
  {
    path: 'take-phone-two',
    loadChildren: () => import('./pages/take-phone-two/take-phone-two.module').then( m => m.TakePhoneTwoPageModule)
  },
  {
    path: 'take-phone-approved',
    loadChildren: () => import('./pages/take-phone-approved/take-phone-approved.module').then( m => m.TakePhoneApprovedPageModule)
  },
  {
    path: 'photo-rejected',
    loadChildren: () => import('./pages/photo-rejected/photo-rejected.module').then( m => m.PhotoRejectedPageModule)
  },
  {
    path: 'photo-approved',
    loadChildren: () => import('./pages/photo-approved/photo-approved.module').then( m => m.PhotoApprovedPageModule)
  },
  {
    path: 'instructions-check-profile',
    loadChildren: () => import('./pages/instructions-check-profile/instructions-check-profile.module').then( m => m.InstructionsCheckProfilePageModule)
  },
  {
    path: 'validate-phone-number',
    loadChildren: () => import('./pages/validate-phone-number/validate-phone-number.module').then( m => m.ValidatePhoneNumberPageModule)
  },
  {
    path: 'validate-code',
    loadChildren: () => import('./pages/validate-code/validate-code.module').then( m => m.ValidateCodePageModule)
  },  
  {
    path: 'home-check-profile',
    loadChildren: () => import('./pages/home-check-profile/home-check-profile.module').then( m => m.HomeCheckProfilePageModule)
  },
  {
    path: 'instructions-pose-photo',
    loadChildren: () => import('./pages/instructions-pose-photo/instructions-pose-photo.module').then( m => m.InstructionsPosePhotoPageModule)
  },
  {
    path: 'likes', 
    loadChildren: () => import('./pages/likes/likes.module').then( m => m.LikesPageModule)
  },
  {
    path: 'theme-settings',
    loadChildren: () => import('./pages/theme-settings/theme-settings.module').then( m => m.ThemeSettingsPageModule)
  }
];
@NgModule({
  imports: [
    RouterModule.forRoot(routes, { preloadingStrategy: PreloadAllModules })
  ],
  exports: [RouterModule]
})
export class AppRoutingModule {}
